export const getErrorMessage = (payload) => {
  if(typeof payload == "string"){
	  return [payload]
  } else if(payload.error?.errorMsg) {
	  return payload.error?.errorMsg;
  } else {
	  return null;
  }
};